import About from "./About"
import Contact from "./Contact"
import Founder from "./Founder"
import MainSection from "./MainSection"
import Objectives from "./Objectives"
import StayConnected from "./StayConnected"
import Survery from "./Survery"
import TayTalk from "./TayTalk"
import Workshops from "./Workshops"

const Body = () => {
  return (
    <div>
      <MainSection />
      <About/>
      <Objectives/>
      <StayConnected/>
      <Survery/>
      <Workshops />
      <TayTalk />
      <Founder />
      <Contact/>
    </div>
  )
}

export default Body
